import { getContrastRatio } from '@material-ui/core';

export const mediaQueries = {
  upXs: '@media (min-width:0px)',
  upSm: '@media (min-width:600px)',
  upMd: '@media (min-width:900px)',
  upLg: '@media (min-width:1200px)',
  upXl: '@media (min-width:1536px)',
};

export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    [mediaQueries.upSm]: { fontSize: pxToRem(sm) },
    [mediaQueries.upMd]: { fontSize: pxToRem(md) },
    [mediaQueries.upLg]: { fontSize: pxToRem(lg) },
  };
}

function hexToHSL(hex) {
  hex = hex.replace(/^#/, '');
  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;

  const max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h *= 60;
  }

  return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
}

function hslToHex(h, s, l) {
  s /= 100;
  l /= 100;
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;

  let r = 0,
    g = 0,
    b = 0;

  if (h < 60) [r, g, b] = [c, x, 0];
  else if (h < 120) [r, g, b] = [x, c, 0];
  else if (h < 180) [r, g, b] = [0, c, x];
  else if (h < 240) [r, g, b] = [0, x, c];
  else if (h < 300) [r, g, b] = [x, 0, c];
  else [r, g, b] = [c, 0, x];

  const toHex = (v) =>
    Math.round((v + m) * 255)
      .toString(16)
      .padStart(2, '0');

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export const createPaletteSet = (color) => {
  const { h, s } = hexToHSL(color);
  return {
    0: hslToHex(h, s, 100),
    25: hslToHex(h, s, 98),
    50: hslToHex(h, s, 95),
    100: hslToHex(h, s, 89),
    200: hslToHex(h, s, 77),
    300: hslToHex(h, s, 66),
    400: hslToHex(h, s, 55),
    500: hslToHex(h, s, 44),
    600: hslToHex(h, s, 36),
    700: hslToHex(h, s, 27),
    800: hslToHex(h, s, 19),
    850: hslToHex(h, s, 17.4),
    900: hslToHex(h, s, 10),
    950: hslToHex(h, s, 0),
  };
};

export const createColorPalette = (color, mode = 'light') => {
  const paletteSet = createPaletteSet(color);

  return {
    lighter: mode === 'dark' ? paletteSet[50] : paletteSet[800],
    light: mode === 'dark' ? paletteSet[300] : paletteSet[700],
    main: color,
    dark: mode === 'dark' ? paletteSet[700] : paletteSet[300],
    darker: mode === 'dark' ? paletteSet[800] : paletteSet[50],
    contrastText: getContrastRatio(color, '#fff') > 3.5 ? '#fff' : '#111',
  };
};

export const hexToRgba = (hex, opacity = 0.2) => {
  if (!hex) return '';

  let cleaned = hex.replace('#', '');

  if (cleaned.length === 3) {
    cleaned = cleaned
      .split('')
      .map((c) => c + c)
      .join('');
  }
  const bigint = parseInt(cleaned, 16);

  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
